"use strict";
exports.KEYS = {
    backspace: 8,
    comma: 188,
    downArrow: 40,
    enter: 13,
    esc: 27,
    space: 32,
    upArrow: 38
};
//# sourceMappingURL=tag-input-keys.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-tag-input/dist/lib/shared/tag-input-keys.js
// module id = 186
// module chunks = 1